/**
 * @description Mapping for all ApplicationData's Status property
 */

export const APPLICATION_STATUS = {
  UnderReview: 'UnderReview',
  Pending: 'Pending',
  Completed: 'Completed'
};

/**
 * @function getUnsubmittedApplication
 * @description Find unsubmitted application on passed flowName
 * @param {Array<Object>} applications
 * @param {String} flowName
 * @returns {Application}
 */

export const getUnsubmittedApplication = (applications, flowName) => {
  if (flowName && typeof flowName !== 'string' && flowName.length <= 0) return {};
  if (!Array.isArray(applications) || applications.length === 0) return {};

  return (
    applications.find((application) => {
      return (
        application?.flowName === flowName &&
        (application?.status === APPLICATION_STATUS.Pending || application?.status === APPLICATION_STATUS.UnderReview)
      );
    }) || {}
  );
};
